import React, { useContext } from 'react';
// material
import Card from '@mui/material/Card';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Alert from '@mui/material/Alert';
import CircularProgress from '@mui/material/CircularProgress';
// context
import { ReportContext } from '../../../contexts/Report';

export default function AppPaymentMethodsList() {
  const { sales, isLoading, hasError } = useContext(ReportContext);

  if (hasError) {
    return (
      <Alert severity="error">
        An error occurred while trying to load the last payment methods — Please, try to refresh the
        page!
      </Alert>
    );
  }

  return (
    <Card sx={{ p: 3, pt: 0 }}>
      <Typography sx={{ mt: 3, mb: 2 }} variant="h6">
        Payment Methods
      </Typography>
      {isLoading ? (
        <Typography align="center" variant="h3">
          <CircularProgress size={30} color="inherit" />
        </Typography>
      ) : (
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 400 }} size="small" aria-label="a dense table">
            <TableHead>
              <TableRow>
                <TableCell width="40">Rank</TableCell>
                <TableCell>Payment Method</TableCell>
                <TableCell width="90" align="center">
                  Quantity
                </TableCell>
                <TableCell width="70" align="right">
                  Amount
                </TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {sales.paid.paymentMethods.map((method, key) => (
                <TableRow key={key} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                  <TableCell component="th" scope="row" align="center">
                    {`#${key + 1}`}
                  </TableCell>
                  <TableCell component="th" scope="row">
                    {method._id || '-'}
                  </TableCell>
                  <TableCell component="th" scope="row" align="center">
                    {method.quantity}
                  </TableCell>
                  <TableCell align="right">{`${method.gross} €`}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Card>
  );
}
